<div class="flex flex-auto flex-col items-center justify-between">
    <!-- Logo -->
    <app-startup-logo> </app-startup-logo>

    <div class="start-up-form-container">
        <!-- Recaptcha container -->
        <div id="recaptcha-container"></div>
        <div class="relative min-w-full">
            <div class="start-up-title">2FA</div>

            <mat-progress-spinner
                *ngIf="!enableCodeInput() || !isRecaptchaSolved()"
                class="absolute left-[46%] top-22"
                [diameter]="24"
                [mode]="'indeterminate'"
            ></mat-progress-spinner>

            <div>
                <p>
                    {{
                        isRecaptchaSolved()
                            ? 'Please enter the 6-digit code sent to your phone.'
                            : 'reCAPTCHA is loading, please wait...'
                    }}
                </p>

                <!-- Alert -->
                @if (showAlert) {
                    <fuse-alert
                        class="mt-2"
                        [appearance]="'outline'"
                        [showIcon]="false"
                        [type]="alert.type"
                        [@shake]="alert.type === 'error'"
                    >
                        {{ alert.message }}
                    </fuse-alert>
                }

                <!-- 2FA form -->
                <form class="mt-3" [formGroup]="twoFaForm">
                    <div
                        class="relative my-5 flex justify-center"
                        [ngClass]="{
                            'opacity-30':
                                !enableCodeInput() || !isRecaptchaSolved(),
                        }"
                    >
                        <app-verification-code
                            [enable]="enableCodeInput() && isRecaptchaSolved()"
                            [reset]="resetCodeInput()"
                            (codeCompleted)="onFillCodeInput($event)"
                        ></app-verification-code>
                    </div>

                    <!-- Actions -->
                    <div class="start-up-actions-container">
                        <a
                            class="start-up-forgot-password mt-1"
                            [routerLink]="['/sign-in']"
                            >Back to sign-in
                        </a>
                        <!-- <a class="start-up-forgot-password mt-1">Resend SMS </a> -->
                    </div>

                    <!-- Submit button -->
                    <!-- <button
                    class="btn btn-primary btn-login"
                    [disabled]="twoFaForm.disabled"
                    (click)="verify()"
                >
                    @if (!twoFaForm.disabled) {
                        <span class="flex-auto text-xl"> Verify Code </span>
                    }
                    @if (twoFaForm.disabled) {
                        <mat-progress-spinner
                            class="mx-auto"
                            [diameter]="24"
                            [mode]="'indeterminate'"
                        ></mat-progress-spinner>
                    }
                </button> -->
                </form>
            </div>
        </div>
    </div>

    <!-- Copyright -->
    <app-copyright></app-copyright>
</div>
